import { Fragment, useContext } from "react"
import { ActionType, ListBrand } from "../../types"
import { Toggle } from "components/actions/Toggle"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { Render } from "../../utils"

export function IsActive({ data, refetch }: ActionType) {
    const api = useApi()
    const { toggle } = useContext(Render)

    const onSubmit = (value: ListBrand) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.put("/assetbrand/changestatus",
                    {
                        mr_brand_id: value.mr_brand_id,
                        asset_brand_del: !value.is_deleted
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            )
            .then(() => {
                toggle()
                refetch && refetch()
            })
            .catch(() => {})
            .finally(resolve)
        })
    }

    return (
        <Fragment>
            <Toggle label="Soft Delete" isChecked={data?.is_deleted} onClick={() => { onSubmit(data!) }} />
        </Fragment>
    )
}